import { type Form as BaseForm, useForm as useBaseForm } from 'laravel-precognition-vue'
import type { Config, RequestMethod, ValidationConfig } from 'laravel-precognition'
import type { AxiosPromise } from 'axios'

export interface Form<Input extends Record<string, unknown>, ResponseData = unknown> extends Omit<BaseForm<Input>, 'submit'> {
  submit: (config?: Config) => AxiosPromise<ResponseData>;
}

export const useForm = <Input extends Record<string, unknown>, ResponseData = unknown>
(
  method: RequestMethod | (() => RequestMethod),
  url: string | (() => string),
  inputs: Input | (() => Input) = {} as Input,
  config: ValidationConfig = {}
): Input & Form<Input, ResponseData> => {
  const baseForm = useBaseForm(method, url, inputs, config)

  return baseForm as Input & Form<Input, ResponseData>
}
